module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderSummaryInfo) ? _c('div', {
    staticClass: "my-1 summary-order-grid fontS14"
  }, [_c('div', [_c('location-svg', {
    staticClass: "address-summary",
    attrs: {
      "primary": ""
    }
  })], 1), _vm._v(" "), (_vm.isDelivered) ? _c('div', {
    staticClass: "line-height-2 d-flex flex-column"
  }, [_c('h4', {
    staticClass: "my-0 fontAvenirBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.pickUpName))]), _vm._v(" "), _c('span', {
    staticClass: "fontS13 fontOpenBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.responsiblePickUp.name))]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("DNI: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.responsiblePickUp.dni))])]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("Teléfono: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.responsiblePickUp.phone))])]), _vm._v(" "), _c('span', {
    staticClass: "fontS13"
  }, [_vm._v("Dirección: "), _c('span', {
    staticClass: "fontOpenBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.customerAddress.name) + " - " + _vm._s(_vm.orderSummaryInfo.customerAddress.addressLine1))])])]) : _c('div', {
    staticClass: "line-height-2 d-flex flex-column"
  }, [_c('h4', {
    staticClass: "my-0 fontAvenirBold"
  }, [_vm._v(_vm._s(_vm.orderSummaryInfo.pickUpName))]), _vm._v(" "), _c('span', [_vm._v("Tienda: " + _vm._s(_vm.orderSummaryInfo.warehouseName))]), _vm._v(" "), _c('span', [_vm._v("Dirección: " + _vm._s(_vm.orderSummaryInfo.warehouseAddress))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9f4e6f4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/summary/addressData.vue
// module id = 1160
// module chunks = 28